import Index from '@/views/buyer/setting/Index.vue';
import CompanyInfo from '@/views/buyer/setting/Company.vue';
import AccountInfo from '@/views/buyer/setting/Account.vue';
import UserInfo from '@/views/buyer/setting/UserInfo.vue';
import { auths, actors } from '@/router/options';

const routes: any[] = [
  {
    path: 'setting',
    component: Index,
    children: [
      {
        name: 'buyer-settings-company',
        path: 'company',
        component: CompanyInfo,
        meta: {
          title: '企業情報',
          actor: actors.buyer,
          auth: auths.required,
        },
      },
      {
        name: 'buyer-settings-account',
        path: 'account',
        component: AccountInfo,
        meta: {
          title: 'アカウント情報',
          actor: actors.buyer,
          auth: auths.required,
        },
      },
      {
        name: 'buyer-settings-userinfo',
        path: 'userinfo',
        component: UserInfo,
        meta: {
          title: '担当者情報',
          actor: actors.buyer,
          auth: auths.required,
        },
      },
    ],
  },
];

export default {
  routes,
};
